const values = (items) => (Array.isArray(items) ? items.map((item) => String(item).trim()).filter(Boolean) : []);

export function descriptorSummary(descriptors) {
  return values(descriptors).join('; ') || '—';
}

export function describeCohortFilter(filter) {
  if (!filter) return [];
  const tags = values(filter.tags);
  const descriptors = values(filter.descriptors);
  const lines = [];
  if (!filter.status?.length || filter.status.includes('active')) lines.push('Active people only');
  else lines.push(`Statuses: ${values(filter.status).join(' or ')}`);
  if (tags.length) lines.push(`Contact-list tags: ${tags.join(' or ')}`);
  if (descriptors.length) lines.push(`Self-described disability or condition: ${descriptors.join(' or ')}`);
  if (String(filter.q ?? '').trim()) lines.push(`Name or email contains: ${String(filter.q).trim()}`);
  const populatedGroups = Number(tags.length > 0) + Number(descriptors.length > 0) + Number(Boolean(String(filter.q ?? '').trim()));
  if (populatedGroups > 1) lines.push('People must match at least one value in each group shown above.');
  return lines;
}
